import { MerchandiseShippingOrderCreationItem } from 'api/order'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'
import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'

const getFormattedMerchandiseShippingItems = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (state: App.State) => state.checkout.form.deliveryForm,
  (state: App.State) => state.destination.googlePlaces,
  (views, form, googlePlaces): Array<MerchandiseShippingOrderCreationItem> => {
    const items = views.data.map((view): MerchandiseShippingOrderCreationItem | undefined => {
      if (!form.phoneNumber ||
        !form.firstName ||
        !form.lastName ||
        !form.address
      ) {
        // doesn't have the necessary fields
        return undefined
      }

      const addressDetails = form.addressPlaceId
        ? googlePlaces[form.addressPlaceId]?.addressDetails
        : undefined

      // Ensure we have complete address details with required fields
      if (!addressDetails?.city || !addressDetails?.state || !addressDetails?.postcode) {
        // Address details are incomplete - user needs to select a valid address
        return undefined
      }

      return {
        type: 'merchandise_shipping',
        transaction_key: view.item.transactionKey,
        total: view.totals.otherFees?.deliveryFee ?? 0,
        shippingGroup: view.item.shippingId,
        address: {
          firstName: form.firstName,
          lastName: form.lastName,
          company: form.company,
          country: addressDetails.country ?? form.country ?? 'Australia',
          phone: `+${form.phoneNumber.prefix}${form.phoneNumber.phone}`,
          address: addressDetails.streetAddress,
          address2: form.unitNumber ?? undefined,
          city: addressDetails.city,
          state: addressDetails.state,
          postcode: addressDetails.postcode,
        },
      }
    })

    return nonNullable(items)
  }
)

export default getFormattedMerchandiseShippingItems
